export const IconStyle = (text: string) => {
  switch (text) {
    case "Nuevo":
      return "AddTo"
    case "Actualizar":
      return "SyncStatus"
    case "Filtrar":
      return "Filter";
    case "Derivar":
      return "Forward";
    case "Editar":
      return "Edit";
    case "Guardar":
      return "Save";
    case "Atrás":
      return "Back";
    case "Excel":
    case "Auditoria":
    case "Descargar":
      return "Download";
    case "Nueva Reunión":
      return "Calendar";
    case "Realizar Monitoreo":
      return "ViewList";
    case "Iniciar Evaluación":
      return "Play";
    case "Finalizar Evaluación":
      return "Completed";
    case "Cancelar":
      return "Cancel";
    case "Enviar":
      return "Send";
    case "Liquidación":
      return "TrendDown";
    case "Liquidaciones":
      return "Edit";
    case "Configurar Monitoreo":
      return "Settings";
    case "Subsanar":
      return "Repair";
    case "Limpiar Filtro":
      return "Breadcrumb"
    case "Eliminar":
      return "Delete";
    case "Notificar Registro":
      return "Mail";
    case "Análisis":
      return "Search";
    case "Nueva Evaluación":
      return "Drafts";
    case "Historial":
      return "History";
    case "Sincronizar":
    case "En Ejecución":
      return "Sync";
    case "Notificar":
      return "Mail";
    default:
      return "Help";
  }
}